var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"obit-nodata"},[_c('svg-icon',{staticClass:"iconDetail",attrs:{"class-name":"iconClass","icon-class":"nodata"}}),_c('br'),_c('span',[_vm._v(_vm._s(_vm.desText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }